import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanActivateViaOAuthGuard } from "../oAuth.canActivateGuard";
import { AdminCanActivateGuard } from "app/shared/guards/admin-can-activate.guard";
import { MainOrderComponent } from "./main-order/main-order.component";
import { OrderDetailsComponent } from "./order-details/order-details.component"
import { SelectNofashimComponent } from "app/favorites-nofashim/select-nofashim/select-nofashim.component";



const routes: Routes = [
  {
      path: 'vouchers', canActivate: [CanActivateViaOAuthGuard] ,children: 
      [
          { path: 'select-supplier', component: MainOrderComponent },
          {path: 'vouchers-order-details',component: OrderDetailsComponent}
      ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class VouchersRouting{

}